import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateThree.css';

const TemplateThree = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    // Generate random skill levels for visualization
    const skillsWithLevels = template?.skills.map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 51) + 50 // Random level between 50 and 100
    }));

    const softwareSkillsWithLevels = template?.softwareSkills.map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 51) + 50 // Random level between 50 and 100
    }));


    return (
        <div className="template-three-container" onClick={() => onClick(template?.id)}>
            <div className="template-three-header">
                {template?.image && <img src={template?.image} alt={template?.personName} className="template-three-image" />}
                {template?.name && <h1 className="template-three-name" >{template?.name}</h1>}
            </div>
            <div className="template-three-details">
                <div className="template-three-header-details">
                    {template?.aboutMe && <p className="template-three-about">{template?.aboutMe}</p>}
                </div>
                {template?.contact && (
                    <div className="template-three-contact-info">
                        <strong>Contact</strong>
                        {template?.contact?.phone && <p><FontAwesomeIcon icon={faPhone} /> {template?.contact.phone}</p>}
                        {template?.contact?.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template?.contact.email}</p>}
                        {template?.contact?.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template?.contact.address}</p>}
                    </div>
                )}
                {template?.languages && template?.languages.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faLanguage} /> Languages:</strong>
                        <p>{template?.languages.join(', ')}</p>
                    </div>
                )}
                {template?.skills && template?.skills.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faToolbox} /> Skills:</strong>
                        <div className="template-three-skills-wrapper">
                            {skillsWithLevels.map((skill, index) => (
                                <div key={index} className="template-three-skill-item">
                                    <span className="template-three-skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {template?.softwareSkills && template?.softwareSkills.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faToolbox} /> SOftware Skills:</strong>
                        <div className="template-three-skills-wrapper">
                            {softwareSkillsWithLevels.map((skill, index) => (
                                <div key={index} className="template-three-skill-item">
                                    <span className="template-three-skill-name">{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {template?.hobbies && template?.hobbies.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faHeart} /> Hobbies:</strong>
                        <p>{template?.hobbies.join(', ')}</p>
                    </div>
                )}
                {template?.workExperience && template?.workExperience.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faBriefcase} /> Work Experience:</strong>
                        {template?.workExperience.map((experience, index) => (
                            <div key={index} className="template-three-work-experience-item">
                                {experience.role && <p className="template-three-role">{experience.role} at {experience.company}</p>}
                                {experience.location && (
                                    <p className="template-three-location">
                                        (
                                        {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                )}
                                {experience.description && <p className="template-three-description">{experience.description}</p>}
                            </div>
                        ))}
                    </div>
                )}
                {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faGraduationCap} /> Education:</strong>
                        {template?.education.map((edu, index) => (
                            <div key={index} className="template-three-education-item">
                                {edu.degree && <p className="template-three-degree">{edu.degree} from {edu.institution}</p>}
                                <p>
                                    (
                                    {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                    {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                    )
                                </p>
                                {edu.description && <p className="template-three-description">{edu.description}</p>}
                            </div>
                        ))}
                    </div>
                )}


                {template?.certificates && template?.certificates.length > 0 && (
                    <div className="template-three-section">
                        <strong><FontAwesomeIcon icon={faGraduationCap} /> Certificates:</strong>
                        {template?.certificates?.map((certificate, index) => (
                            <div key={index} className="template-three-education-item">
                                <p className="template-three-degree">Title: {certificate.title}</p>
                                <p className="template-three-institution">Institution: {certificate.institution}</p>
                                <p className="template-three-date">
                                    Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                {template?.links && template?.links.length > 0 && (
                    <div className="template-three-section">
                        <div className="template-three-links">
                            <strong>Links:</strong>
                            {template.links.map(([key, value]) => (
                                <p key={key} className="template-three-link">
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                </p>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

export default TemplateThree;
